<template>
  <div>
    <appModal/>
    <Header />
    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <AdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <h4>Users Update</h4>

              <br />
              <p>
                This tool will allow you to merge a Users Report and a HR
                Staffing file to update users and lock users that are terminated
                more than 30 days ago and set thier points to zero. Create any
                missing users that are active.
              </p>
              <br />
              <p>
                <strong>Important:</strong> none of the files mentioned will be
                uploaded to the server. The merge will happen in your computer.
                This only means that none of the information contained in your
                HR Staffing will at any point leave your computer.
              </p>
              <hr />
              <a-spin
                tip="Please wait it may take a while"
                :spinning="processing"
              >
                <!-- <b-form @submit.prevent="updateUsers"> -->
                <div class="row border rounded">
                  <div class="col p-2">
                    <p style="color: black"><strong> Users Report</strong></p>
                    <p>
                      This is the file you can download from Incentiveweb in the
                      Build New User File section of the
                      <router-link
                        :to="{
                          name: 'AdminBatchUserUploadTool',
                          params: {
                            activeMenuItem: 'usersBatchUserUploadTool',
                            activeMenu: 'users',
                          },
                        }"
                      >
                        Batch User-Upload Tool
                      </router-link>
                      section.
                    </p>

                    <fieldset class="border rounded upload">
                      <input
                        class="p-3"
                        type="file"
                        id="ordersReport"
                        @change="handleUsersReportFileSelect"
                      />
                    </fieldset>
                    <CSVToExcelInstructions></CSVToExcelInstructions>
                  </div>
                  <div class="col p-2">
                    <p style="color: black"><strong> HR Staffing</strong></p>
                    <p>
                      This file must come from your organization and contain a
                      sheet called Active with at least the columns:
                    </p>
                    <p>- EMPLOYEE_NUMBER</p>
                     <p>-N#</p>
                    <p>- EMPLOYEE_FIRST_NAME</p>
                    <p>- EMPLOYEE_LAST_NAME</p>
                    <p>- EMPLOYEE_EMAIL_ADDRESS</p>
                    <fieldset class="border rounded upload">
                      <input
                        class="p-3"
                        type="file"
                        id="hrStaffing"
                        @change="handleHRStaffingFileSelect"
                      />
                    </fieldset>
                  </div>
                </div>
                <button
                  @click="updateUsers"
                  :disabled="hasBatchUsersSummary"
                  class="btn btn-primary mt-2 mb-3"
                >
                  Merge
                </button>
                <!-- </b-form> -->
              </a-spin>
              <div class="overflow-auto">
                <p v-if="hasBatchUsersSummary"><strong>Confirm the Pending Changes Below</strong></p>
                <UserUploadSummary :previousRoute="previousRoute" activeMenuItem="usersUpdate" />
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script >
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import UserUploadSummary from "../../../../components/UserUploadSummary.vue";
import Modal from "@/components/Modal.vue";
import CSVToExcelInstructions from "../../../../components/CSVToExcelInstructions.vue";
import {
  handleUsersReportFileSelect,
  handleHRStaffingFileSelect,
  updateUsers,
  processUserAdds,
  deleteAllRecords,
  finalize,
} from "./users-update";
import { addUserJSONData } from "../../../../api/batch-user-upload-tool";

export default {
  name: "GenerateExcelReport",
  data() {
    return {
      previousRoute : "UsersUpdate",
      currentPage: 1,
      perPage: 10,
      incompleteUsers: [],
      incompleteUsersFinal: [],
      filteredUsers: [],
      selectedDeptCodes: [],
      selectedJobCodes: [],
      showDeptSelectModal: false,
      processing: false,
      uploadSummary: "",
      uploadCompleteMessage: "",
      uploadStatus: "",
      showUploadModal: false,
      showUploadSummary: false,
      incompleteUsersForm: this.$form.createForm(this, {
        name: "createUserForm",
      }),
      editusersToCreateId: "",
      incompleteUsersFields: [
        {
          title: "N#",
          key: "N#",
          dataIndex: "N#",
          scopedSlots: { customRender: "N#" },
          ellipsis: true,
        },
        {
          title: "Email",
          key: "EMPLOYEE_EMAIL_ADDRESS",
          dataIndex: "EMPLOYEE_EMAIL_ADDRESS",
          scopedSlots: { customRender: "EMPLOYEE_EMAIL_ADDRESS" },
          ellipsis: true,
        },
        {
          title: "First Name",
          key: "EMPLOYEE_FIRST_NAME",
          dataIndex: "EMPLOYEE_FIRST_NAME",
          scopedSlots: { customRender: "EMPLOYEE_FIRST_NAME" },
          ellipsis: true,
        },
        {
          title: "Middle Name",
          key: "EMPLOYEE_MIDDLE_NAME",
          dataIndex: "EMPLOYEE_MIDDLE_NAME",
          scopedSlots: { customRender: "EMPLOYEE_MIDDLE_NAME" },
          ellipsis: true,
        },
        {
          title: "Last Name",
          key: "EMPLOYEE_LAST_NAME",
          dataIndex: "EMPLOYEE_LAST_NAME",
          scopedSlots: { customRender: "EMPLOYEE_LAST_NAME" },
          ellipsis: true,
        },
        {
          title: "Job Code",
          key: "JOB_CODE",
          dataIndex: "JOB_CODE",
          scopedSlots: { customRender: "JOB_CODE" },
          ellipsis: true,
        },
        {
          title: "Dept. Code",
          key: "DEPT_CODE",
          dataIndex: "DEPT_CODE",
          scopedSlots: { customRender: "DEPT_CODE" },
          ellipsis: true,
        },
        {
          title: "Edit",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          ellipsis: true,
        },
      ],
      UploadSummaryFields: [
        {
          key: "action",
        },
        {
          key: "status",
        },
        {
          key: "total",
          tdClass: "text-right",
        },
      ],
    };
  },
  components: {
    AdminSidebar,
    Header,
    Footer,
    UserUploadSummary,
    appModal: Modal,
    CSVToExcelInstructions
  },
  computed: {
    rows() {
      return this.filteredUsers.length;
    },
    hasBatchUsersSummary() {
      const summ = this.$store.getters["adminBatchUserUploadTool/getAllBatchUserSummary"]
      return summ != null && summ.length > 0 
    },
    getModalMessage() {
      return this.$store.getters["systemMessage/getModalMessage"];
    },
  },

  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersUpdate",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
    },
    handleUsersReportFileSelect() {
      handleUsersReportFileSelect();
    },
    handleHRStaffingFileSelect() {
      handleHRStaffingFileSelect();
    },
    async updateUsers() {
      this.processing = true;
      const { incompleteUsers, filterdUsers } = await updateUsers()
        .then((res) => {
          return res;
        })
        .finally(() => {
          this.processing = false;
        });

      this.incompleteUsers = incompleteUsers.map((user, index) => ({
        ...user,
        id: index,
      }));
      this.incompleteUsersFinal = incompleteUsers.map((user, index) => ({
        ...user,
        id: index,
      }));
      this.editusersToCreateId = "";
      this.incompleteUsersForm = this.$form.createForm(this, {
        name: "createUserForm",
      });
      this.filteredUsers = filterdUsers;
      if (this.incompleteUsers.length > 0) {
        this.showDeptSelectModal = true;
      } else {
        this.showDeptSelectModal = false;
        this.uploadSummary = await processUserAdds(
          this.filteredUsers,
          this.incompleteUsersFinal
        );
        console.log(this.filteredUsers);
        this.showUploadSummary = true;
      }

      await this.insertUserFileData();
    },
    async processUserAdds() {
      this.showDeptSelectModal = false;
      this.uploadSummary = await processUserAdds(
        this.filteredUsers,
        this.incompleteUsersFinal
      );
      this.showUploadSummary = true;
    },
    toggleDeptUpload() {
      this.showDeptSelectModal = false;
    },
    toggleUploadSummary() {
      this.showUploadModal = false;
    },
    deleteAllRecords() {
      deleteAllRecords();
      this.showUploadSummary = false;
    },
    finalize() {
      finalize();
      this.showUploadSummary = false;
    },
    edit(key) {
      const newData = [...this.incompleteUsers];
      const target = newData.filter((item) => key === item.id)[0];
      this.editusersToCreateId = key;
      if (target) {
        target.editable = true;
        this.incompleteUsers = newData;
      }
    },
    save(key) {
      this.incompleteUsersForm.validateFields((errors, values) => {
        if (!errors) {
          this.editusersToCreateId = "";
          const newData = [...this.incompleteUsers];
          const newCacheData = [...this.incompleteUsersFinal];
          const target = newData.filter((item) => key === item.id)[0];
          Object.assign(target, {
            ...target,
            ...values,
          });
          const targetCache = newCacheData.filter((item) => key === item.id)[0];
          if (target && targetCache) {
            delete target.editable;
            this.incompleteUsers = newData;
            Object.assign(targetCache, target);
            this.incompleteUsersFinal = newCacheData;
          }
        }
      });
    },
    cancel(key) {
      const newData = [...this.incompleteUsers];
      const target = newData.filter((item) => key === item.id)[0];
      this.editusersToCreateId = "";
      if (target) {
        Object.assign(
          target,
          this.incompleteUsersFinal.filter((item) => key === item.id)[0]
        );
        delete target.editable;
        this.incompleteUsers = newData;
      }
    },
    async insertUserFileData() {
      try {
        this.processing = true;
        // workaround due to tons of type mismatches - can be fixed when typescript is implemented
        const copyUsers = JSON.parse(JSON.stringify(this.filteredUsers));

        for (let user of copyUsers) {
          if (typeof user.UserId == "string") {
            try {
              user.UserId = parseInt(user.UserId);
            } catch (e) {
              user.UserId = 0;
            }
          }

          if (user.SingleItem == "0" || user.SingleItem == 0) {
            user.SingleItem = false;
          } else {
            user.SingleItem = true;
          }
          if (typeof user.Administrator == "string") {
            user.Administrator = parseInt(user.Administrator);
          }

          if (user.Disabled == "0" || user.Disabled == 0) {
            user.Disabled = false;
          } else {
            user.Disabled = true;
          }

          if (typeof user.Program_id == "string") {
            user.Program_id = parseInt(user.Program_id);
          }

          if (isNaN(user.Program_id)) {
            user.Program_id = 0;
          }

          if (typeof user.company_id == "string") {
            user.company_id = parseInt(user.company_id);
          }
        }
        const resp = await addUserJSONData(copyUsers);

        // this.showUploadModal = true;
        if (resp.status != 200) {
          console.error(resp.data);
          console.error(resp.status);
          //this.uploadCompleteMessage = resp.data.message;
          //this.uploadStatus = "Upload Failed!";
        } else {
          // summary update
          this.$store.dispatch(
            "adminBatchUserUploadTool/fetchUserUploadSummary"
          );
          // this.uploadCompleteMessage = "Users have been successfully uploaded!";
          // this.uploadStatus = "Upload Complete!";

          // open modal, show message
          this.$store.dispatch("systemMessage/setModalMessage", {
            message:
              "Your data has been uploaded. Use the tools below to edit and finalize your inserts and updates",
          });
          this.getFormUsers();
        }
      } catch (e) {
        console.error(`error from batch user upload: ${e}`);
      }

      this.processing = false;
    },
    async getFormUsers() {
      await this.$store.dispatch("adminBatchUserUploadTool/fetchUsersPrograms");
    },
  },
  async mounted() {
    this.setActiveMenuItem();
    this.scrollToTop();
    this.$store.dispatch("adminBatchUserUploadTool/fetchUserUploadSummary");
    await this.getFormUsers();
  },
  created() {
    this.setActiveMenuItem();

    var scriptTag1 = document.createElement("script");
    scriptTag1.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.16.8/shim.min.js";
    document.getElementsByTagName("head")[0].appendChild(scriptTag1);
    var scriptTag2 = document.createElement("script");
    scriptTag2.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.16.8/xlsx.full.min.js";
    document.getElementsByTagName("head")[0].appendChild(scriptTag2);
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}

fieldset {
  background-image: url("https://qa.incentiveweb.com/images/blue_bg.png");
}

.editable-row-operations span {
  display: flex;
  gap: 20%;
}
</style>
<style lang="scss">
.ant-form-explain {
  width: 7.5em;
  white-space: pre-wrap;
}

.ant-modal-content {
  .ant-table-pagination.ant-pagination {
    justify-content: end;

    .ant-pagination-next,
    .ant-pagination-total-text {
      display: block;
    }

    .ant-pagination-total-text {
      margin-right: auto;
    }
  }
}
</style>
